 <div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Modifica Opera/Inserimento dati aggiuntivi">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="operaModificaAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="operaModificaAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                        <button ngbDropdownItem (click)="updateOpera()">
                            <app-toolkit-bl-icon icon="check-circle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Salva
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                <ngb-panel id="tab-1" title="Progetto" *ngIf="operaService.operaSession.tipoInserimento === 1">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-piano-interventi [canEdit]="permessiService.opera['OPERA_EDIT']" [formGroup]="criteriaForm" [items]="pianoInterventiOperaList" [datalist]="datalist"></app-toolkit-opera-tab-piano-interventi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-1" title="Rilievo" *ngIf="operaService.operaSession.tipoInserimento === 2">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-piano-rilievi [canEdit]="true" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-piano-rilievi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-2" title="Anagrafica dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-anagrafica-opera [canEdit]="permessiService.opera['OPERA_EDIT']" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-anagrafica-opera>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-3" title="Dati costruttivi dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-dati-costruttivi-opera [canEdit]="permessiService.opera['OPERA_EDIT']" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-dati-costruttivi-opera>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-4" title="Opere secondarie dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-opere-secondarie [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="operaSecondariaList" [datalist]="datalist"></app-toolkit-opera-tab-opere-secondarie>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-5" title="Documenti a corredo">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-documenti [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="documentoOperaList" [datalist]="datalist"></app-toolkit-opera-tab-documenti>
                    </ng-template>
                </ngb-panel>
                <!--<ngb-panel id="tab-6" title="Sopralluoghi">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-sopralluoghi [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="rilevamentoOperaList" [datalist]="datalist"></app-toolkit-opera-tab-sopralluoghi>
                    </ng-template>
                </ngb-panel>-->
                <ngb-panel id="tab-6" title="Sopralluoghi/Monitoraggi">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-monitoraggi-sopralluoghi [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="monitoraggiSopralluoghiList" [datalist]="datalist" [formGroup]="criteriaForm"></app-toolkit-opera-tab-monitoraggi-sopralluoghi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-7" title="Manutenzione">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-manutenzione [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="manutenzioneOperaList" [datalist]="datalist" [formGroup]="criteriaForm"></app-toolkit-opera-tab-manutenzione>
                    </ng-template>
                </ngb-panel>
                <!--<ngb-panel id="tab-8" title="Monitoraggio">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-monitoraggio [canEdit]="permessiService.opera['OPERA_EDIT']" [items]="monitoraggioOperaList" [datalist]="datalist"></app-toolkit-opera-tab-monitoraggio>
                    </ng-template>
                </ngb-panel>-->
                
               
            </ngb-accordion>
        </div>
    </div>
</div>